// merchantTypesData.tsx

import { ReactNode } from "react";

import { useState } from "react";
import { Modal, Button, ListGroup } from "react-bootstrap";
// import { merchantTypes } from "./merchantTypesData";

export interface MerchantType {
  id: string;
  name: ReactNode;
  
}

export const merchantTypes: MerchantType[] = [
  { id: "retail", name: <>Retail Stores</> },
  { id: "restaurants", name: <>Restaurants & Cafes</> },
  { id: "salons", name: <>Salons & Spas</> },
  { id: "auto", name: <>Auto Services</> },
  { id: "contractors", name: <>Contractors / Home Services</> },
  { id: "medical", name: <>Medical Practices</> },
  { id: "dental", name: <>Dental Practices</> },
  { id: "veterinary", name: <>Veterinary / Specialty Healthcare</> },
  { id: "professional", name: <>Professional Services</> },
  { id: "hospitality", name: <>Hospitality (Hotels, Resorts)</> },
  { id: "travel", name: <>Travel & Tourism</> },
  { id: "events", name: <>Event & Ticketing</> },
  { id: "subscription", name: <>Membership / Subscription Businesses</> },
  { id: "education", name: <>Education & Training</> },
  { id: "nonprofits", name: <>Nonprofits / Donations</> },
  { id: "transport", name: <>Transportation & Logistics</> },
  { id: "financial", name: <>Financial Services</> },
  { id: "highrisk", name: <>High-Risk Merchants</> },
  { id: "ecommerce", name: <>eCommerce Brands</> },
  { id: "digital", name: <>Digital Products / SaaS</> },
  { id: "b2b", name: <>B2B / Wholesale / Manufacturing</> }
];


// MerchantTypesModal_v01.tsx
// Version: v01



const MerchantTypesModal_v01 = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      {/* Trigger */}
      <a href="#" onClick={(e) => { e.preventDefault(); setShow(true); }}>
        View All Merchant Types
      </a>

      {/* Modal */}
      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Complete Merchant Types List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ListGroup variant="flush">
            {merchantTypes.map((item) => (
              <ListGroup.Item key={item.id}>
                {item.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MerchantTypesModal_v01;

// File: MerchantTypesModal_v01.tsx
// Description: Bootstrap modal displaying merchant types list
// Version: v01
